const publistHead = [
  {
    title: '序号',
    slot: 'sort',
    width: 60,
    fixed: 'left'
  }
];
const publistFoot = [
  {
    title: '任务ID',
    key: 'jobId',
    width: 170
  },
  {
    title: '任务名称',
    key: 'jobName',
    width: 120
  },
  {
    title: 'beanName',
    key: 'beanName',
    width: 200
  },
  {
    title: '任务参数',
    key: 'params',
    width: 120
  },
  {
    title: '表达式',
    key: 'cronExpression',
    width: 100
  },
  {
    title: '创建时间',
    key: 'createTime',
    width: 200
  },
  {
    title: '备注',
    key: 'remark',
    width: 200
  },
  {
    title: '状态',
    key: 'status',
    render: (h, params) => {
      // 0-生效，1-停用，2-删除
      let s = params.row.status;
      let t = s == 2 ? '删除' : s == 1 ? '停用' : '生效';
      return h('span', t);
    },
    width: 80,
    fixed: 'right'
  }, {
    title: "操作",
    slot: 'action',
    width: 150,
    fixed: 'right'
  }
];

const columns = {
  jobName: [
    ...publistHead,
    ...publistFoot
  ]
};

export default columns;



// WEBPACK FOOTER //
// ./src/views/task/columns.js